import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import { store as uiStore } from "../store/ui";
import * as HelperSrc from "../HelperSrc";

async function downloadPreparation(workbook: string): Promise<boolean> {
    if (!api.workbookApi) {
        return false;
    }
    return api.workbookApi.downloadPreparation(store.db ? store.db : "", workbook, uiStore.downloadTime).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }
            return false;
        }

        return true;
    });
}

export { downloadPreparation };
